import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { ICompaniesState } from 'store/company/interfaces';
import { FetchingStatus } from 'store/interfaces';
import { checkUserComboId } from './checkUserComboId';

export const checkUserComboIdExtraReducer = (builder: ActionReducerMapBuilder<ICompaniesState>) => {
  builder.addCase(checkUserComboId.pending, (state, action) => {
    state.hris.fetchingStatus = FetchingStatus.PENDING;
    state.hris.error = null;
    state.hris.komboId = null;
  });
  builder.addCase(checkUserComboId.fulfilled, (state, action) => {
    if (action.payload.data.endusers.length > 0) {
      state.hris.komboId = action.payload.data.endusers[0].id;
    } else {
      state.hris.attempts += 1;
      state.hris.komboId = null;
      state.hris.error = { code: 'USER_CANT_MATCH' };
    }
    state.hris.fetchingStatus = FetchingStatus.FULFILLED;
  });

  builder.addCase(checkUserComboId.rejected, (state, action) => {
    state.hris.attempts += 1;
    state.hris.error = action.error;
    state.hris.fetchingStatus = FetchingStatus.REJECTED;
  });
};
